import { memo, useState } from 'react'
import { motion } from 'framer-motion'

import useResponsiveHp from 'hooks/useResponsiveHp'
import Tabs from './Tabs'
import LiveUpdates from './LiveUpdates'

const Sidebar = () => {
  const [tabsExpanded, setTabsExpanded] = useState(false)
  const [luExpanded, setLuExpanded] = useState(false)
  const hp = useResponsiveHp()

  // Constrain to available height: full virtual viewport minus the top bar
  // (48px), sidebar icon row (68px), top margin/padding (32px), and footer (24px).
  const maxHeight = hp(100) - 172

  return (
    <motion.div
      className="mt-8 pt-8 overflow-hidden"
      style={{ maxHeight }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Tabs expanded={tabsExpanded} setExpanded={setTabsExpanded} hidden={luExpanded} />
      <LiveUpdates expanded={luExpanded} setExpanded={setLuExpanded} />
    </motion.div>
  )
}

Sidebar.whyDidYouRender = true

export default memo(Sidebar)
